export type BillingFrequency = 'month' | 'year';

export const BILLING_FREQUENCIES: {
  value: BillingFrequency;
  label: string;
  detail: string;
}[] = [
  { value: 'month', label: 'Monthly', detail: 'per month' },
  { value: 'year', label: 'Yearly', detail: 'per year' },
];
